<template>
    <div class="translate-column-wrapper">
        <div class="translate-question-data">
            <span class="text">
                <span class="translate-badge" v-show="getBadgeText(row.translateServer)" >
                    {{ getBadgeText(row.translateServer) }}
                </span>
                {{ row.questionTranslate }}
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name: "TranslateColumn",
    props: ["row"],
    methods: {
        getBadgeText(translateServer) {
            const serverMap = {
                '0': '腾讯交互',
                '1': '腾讯云',
                '2': 'Google',
                '3': '混元'
            };
            return serverMap[String(translateServer)] || '';
        },
    }
}
</script>

<style lang="less" scoped>
.translate-column-wrapper {
    position: relative;

    .translate-question-data {
        padding-right: 8px;
        word-break: break-all;
        word-wrap: break-word;
        overflow: hidden;
        height: 34px;
        align-items: center;
        line-height: 17px;
        display: flex;
        
        .text {
            max-height: 34px;
        }
    }

    .translate-badge {
        line-height: 14px;
        height: 14px;
        min-width: 26px;
        padding: 2px 2px 2px 4px;
        box-sizing: border-box;
        text-align: center;
        color: #fff;
        border-radius: 7px;
        margin-right: 4px;
        white-space: nowrap;
        font-size: 10px;
        background: #2ec2ff;
    }
}
</style>